import { EnterAmountType } from './EnterAmountProvider';

export const EnterAmountParams = {
  TYPE: 'type',
  CARD_UID_FROM: 'cardUidFrom',
  CARD_UID_TO: 'cardUidTo',
  SENDER: 'sender',
  RECEIVER: 'receiver',
  ORGANIZATION_CODE: 'organizationCode',
  AMOUNT: 'amount',
  MERCHANT_ID: 'merchantId',
};

export default class EnterAmountParser {
  static parseURLParams(currentParams) {
    const type =
      currentParams.get(EnterAmountParams.TYPE)?.toUpperCase() ||
      EnterAmountType.P2P;
    switch (type) {
      case EnterAmountType.P2P:
        const cardUidFrom = currentParams.get(EnterAmountParams.CARD_UID_FROM);
        const cardUidTo = currentParams.get(EnterAmountParams.CARD_UID_TO);
        return {
          cardUidFrom: cardUidFrom,
          cardUidTo: cardUidTo,
          service: EnterAmountType.P2P,
        };
      case EnterAmountType.MICROLOAN: {
        const organizationCode = currentParams.get(
          EnterAmountParams.ORGANIZATION_CODE,
        );
        return {
          service: EnterAmountType.MICROLOAN,
          organizationCode: organizationCode,
        };
      }
      case EnterAmountType.MICROLOAN_PAYMENT: {
        const organizationCode = currentParams.get(
          EnterAmountParams.ORGANIZATION_CODE,
        );
        return {
          service: EnterAmountType.MICROLOAN_PAYMENT,
          organizationCode: organizationCode,
        };
      }
      case EnterAmountType.POS: {
        const organizationCode = currentParams.get(
          EnterAmountParams.ORGANIZATION_CODE,
        );
        const merchantId = currentParams.get(EnterAmountParams.MERCHANT_ID);
        return {
          service: EnterAmountType.POS,
          organizationCode: organizationCode,
          merchantId: merchantId,
        };
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        const organizationCode = currentParams.get(
          EnterAmountParams.ORGANIZATION_CODE,
        );
        return {
          service: EnterAmountType.SEND_MONEY_TO_COMPANY,
          organizationCode: organizationCode,
        };
      }
    }
  }

  static parseResponse(t, currentParams, type, data, getOrganization) {
    switch (type?.toUpperCase()) {
      case EnterAmountType.P2P: {
        return {
          sender: data?.cardFrom,
          receiver: data?.cardTo,
          commission: data?.commission,
        };
      }
      case EnterAmountType.MICROLOAN: {
        return {
          sender: { name: data?.sender.name, balance: data?.amounts.max },
          receiver: {
            name: getOrganization(data?.beneficiary.organizationCode),
            organizationCode: data?.beneficiary.organizationCode,
          },
          commission: data?.commission,
          params: { min: data?.amounts.min },
          amounts: data?.amounts,
        };
      }
      case EnterAmountType.MICROLOAN_PAYMENT: {
        return {
          sender: {
            organizationCode: data?.sender.organizationCode,
            balance: data?.amounts.max,
          },
          receiver: { name: t('Credit repayment') },
          commission: data?.commission,
          defaultAmount: data?.amounts.value,
        };
      }
      case EnterAmountType.POS: {
        return {
          sender: {
            balance: data?.balance,
            organizationCode: data?.sender.organizationCode,
          },
          commission: {
            service: EnterAmountType.POS,
            value: 0,
            currency: data?.sender.currency,
          },
          receiver: data?.beneficiary,
          params: { amount: data?.amount, merchantId: data?.merchantId },
        };
      }
      case EnterAmountType.SEND_MONEY_TO_COMPANY: {
        return {
          sender: {
            balance: data?.balance,
            organizationCode: data?.sender.organizationCode,
          },
          commission: {
            service: EnterAmountType.SEND_MONEY_TO_COMPANY,
            value: 0,
            currency: data?.sender.currency,
          },
          receiver: data?.beneficiary,
          params: { amount: data?.amount },
        };
      }
    }
  }
}
